import { render, staticRenderFns } from "./GerirTemplates.vue?vue&type=template&id=2ce59647&scoped=true"
import script from "./GerirTemplates.vue?vue&type=script&lang=js"
export * from "./GerirTemplates.vue?vue&type=script&lang=js"
import style0 from "./GerirTemplates.vue?vue&type=style&index=0&id=2ce59647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce59647",
  null
  
)

export default component.exports